import { Carousel } from './carousel';

export class ProductSupportingCarouselFrost extends Carousel {
  /**
   * css selector of carousel container
   * @static
   */
  static selector = '.js-product-supporting-carousel-frost';

  /**
   * Checks if container node is present in the dom
   * @function isOnPage
   * @returns {Boolean}
   * @static
   */
  static isOnPage() {
    return document.querySelector(ProductSupportingCarouselFrost.selector);
  }

  constructor() {
    super();

    this.carousel = new Map();
    super.init(this, ProductSupportingCarouselFrost.selector);
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @param {Node} $carousel - Carousel DOM Node
   * @returns {Object} extended config
   */
  generateConfig($carousel) {
    if (super.hasSingleSlide($carousel)) {
      return super.extendConfig({
        pagination: false,
        loop: false,
        autoplay: false,
      });
    }

    const isLeukoplast = $carousel.getAttribute('isLeukoplast') === 'true';

    if (isLeukoplast) {
      return super.extendConfig({
        slidesPerView: 1.5,
        loop: false,
        spaceBetween: 15,
        scrollbar: {
          el: '.product-supporting-carousel-frost .swiper-scrollbar',
          hide: false,
          draggable: true
        },
        breakpoints: {
          768: {
            spaceBetween: 15,
            slidesPerView: 3.2,
          },
          992: {
            spaceBetween: 15,
            slidesPerView: 4,
          },
        }
      });
    }

    return super.extendConfig({
      slidesPerView: 2.5,
      loop: false,
      spaceBetween: 15,
      scrollbar: {
        el: '.product-supporting-carousel-frost .swiper-scrollbar',
        hide: false,
        draggable: true
      },
      breakpoints: {
        992: {
          spaceBetween: 15,
          slidesPerView: 4,
        },
      }
    });
  }
}